import infoCircleIcon from '~/assets/images/icons/menus/info-circle.svg';
import questionCircleIcon from '~/assets/images/icons/menus/question-circle.svg';

export interface NavLink {
  label: string;
  to: string;
  icon?: string;
}

export const TOPBAR_NAV: NavLink[] = [
  { label: 'Home', to: '/' },
  { label: 'Candidates', to: '/candidates' },
  { label: 'Parties', to: '/parties' },
  { label: 'Campaigns', to: '/campaigns' },
  { label: 'Sources', to: '/sources' },
  { label: 'Support', to: '/support' },
];

export const MOBILE_MENU_NAV: NavLink[] = [
  { label: 'Home', to: '/', icon: 'solar:home-angle-linear' },
  {
    label: 'Candidates',
    to: '/candidates',
    icon: 'solar:users-group-two-rounded-linear',
  },
  { label: 'Parties', to: '/parties', icon: 'solar:flag-linear' },
  { label: 'Campaigns', to: '/campaigns', icon: 'solar:notes-linear' },
  { label: 'Sources', to: '/sources', icon: 'solar:link-round-linear' },
  {
    label: 'Help Centre',
    // Help Centre lives at /support (spec §6); no separate /help-centre route.
    to: '/support',
    icon: questionCircleIcon,
  },
  { label: 'About', to: '/about', icon: infoCircleIcon },
];

// The Support section's own menu. Both entries are real routes, so the sidebar
// on /support and /about is shared chrome rather than per-page tab state.
export const SUPPORT_MENU: NavLink[] = [
  {
    label: 'Help Centre',
    to: '/support',
    icon: 'solar:question-circle-linear',
  },
  { label: 'About', to: '/about', icon: 'solar:info-circle-linear' },
];

// Support sub-pages that live at their own top-level route rather than under
// /support, so neither the router nor a path-prefix check can infer the
// section. Listed here so the topbar "Support" tab and the Help Centre menu
// cell stay highlighted while the user is on one of them.
export const SUPPORT_SECTION_PATHS = ['/contact-us'];

// The section a "Help us improve this information" link's `report_type` query
// param belongs to. /report-a-problem's back button and breadcrumb use this to
// return to the entity's section (e.g. Campaigns) instead of always falling
// back to Support, which is only correct when the report was filed generically
// rather than from a candidate/party/campaign page.
export const REPORT_ENTITY_SECTIONS: Record<
  string,
  { label: string; to: string }
> = {
  candidates: { label: 'Candidates', to: '/candidates' },
  parties: { label: 'Parties', to: '/parties' },
  campaigns: { label: 'Campaigns', to: '/campaigns' },
};

export const FOOTER_LINKS: NavLink[] = [
  { label: 'Home', to: '/' },
  { label: 'Candidates', to: '/candidates' },
  { label: 'Parties', to: '/parties' },
  { label: 'Campaigns', to: '/campaigns' },
];

export const FOOTER_ABOUT: NavLink[] = [
  { label: 'Terms of Service', to: '/terms-of-use' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
];

// Figma labels this footer group "Help" (the Support page still lives at
// /support — only the footer heading and grouping changed).
export const FOOTER_HELP: NavLink[] = [
  { label: 'Contact Us', to: '/contact-us' },
  { label: 'Report a Problem', to: '/report-a-problem' },
];
